import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const APP_TITLE = 'NABP Compliance Services Dashboard';

/**
 * Gives every page a unique, descriptive browser-tab title (WCAG 2.4.2) from its
 * route's `title` — "Reports | NABP Compliance Services Dashboard" — so screen
 * reader users hear where they landed after each navigation. Routes without a
 * title fall back to the app name.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const page = this.buildTitle(snapshot);
    this.title.setTitle(page ? `${page} | ${APP_TITLE}` : APP_TITLE);
  }
}
